import { render, staticRenderFns } from "./DeleteMicrolearning.vue?vue&type=template&id=b0936096&scoped=true"
import script from "./DeleteMicrolearning.vue?vue&type=script&lang=js"
export * from "./DeleteMicrolearning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0936096",
  null
  
)

export default component.exports